module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main success"
  }, [_c('div', {
    staticClass: "part1 blue"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('prices-success-title1')))]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('prices-success-title2')))])]), _vm._v(" "), _c('div', {
    staticClass: "part2"
  }, [_vm._v(_vm._s(_vm.$t('prices-success-title3')) + "："), _c('span', {
    staticClass: "blue"
  }, [_vm._v(_vm._s(_vm.account))])]), _vm._v(" "), _c('div', {
    staticClass: "part3"
  }, [_vm._v(_vm._s(_vm.$t('prices-success-title4')) + "："), _c('span', {
    staticClass: "blue"
  }, [_vm._v(_vm._s(_vm.paymentPlan))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d189cb64"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Prices/Success.vue
// module id = 305
// module chunks = 1